const LOADPAGE = (state) => {
  state.loadpage = !state.loadpage
}
const APPINSTANCE = (state, instance) => {
  state.appInstance = instance
}
const SETORIENTATION = (state, orientation) => {
  state.orientation = orientation
}
const KEEPPAGESTATE = (state, pageState) => {
  state.keepPageState = pageState
}
const IMAGETOVIEW = (state, prevent) => {
  state.imageToView = prevent
}
const PRODUCTIMAGETOVIEW = (state, images) => {
  state.productImageToView = images
}
const MESSAGEDATA = (state, data) => {
  state.messageData = data
}

export default {
  LOADPAGE,
  APPINSTANCE,
  SETORIENTATION,
  KEEPPAGESTATE,
  IMAGETOVIEW,
  MESSAGEDATA,
  PRODUCTIMAGETOVIEW
}
